(() => {
  if (window.WENNEBIRD_MTO_CONFIRMATION_LOADED) return;
  window.WENNEBIRD_MTO_CONFIRMATION_LOADED = true;
  window.WENNEBIRD_MTO_CONFIRMATION_VERSION = '20261009-r22-cart-pending';
  const selector = '[data-wb-mto-confirmation]';
  const ready = (root) => root.dataset.wbHasUnknown !== 'true' && root.dataset.wbCartPending !== 'true' && Boolean(root.querySelector('[data-wb-mto-checkbox]')?.checked);
  function sync(root) {
    const confirmed = ready(root);
    const checkout = document.getElementById(root.dataset.wbCheckoutId);
    const attribute = root.querySelector('[data-wb-mto-attribute]');
    if (checkout) {
      checkout.disabled = !confirmed;
      checkout.setAttribute('aria-disabled', String(!confirmed));
    }
    if (attribute) attribute.disabled = !confirmed;
    if (confirmed) root.querySelector('[role="alert"]').hidden = true;
  }
  function initialize() {
    document.querySelectorAll(selector).forEach((root) => {
      if (root.dataset.wbInitialized !== 'true') {
        root.dataset.wbInitialized = 'true';
        root.querySelector('[data-wb-mto-checkbox]')?.addEventListener('change', () => sync(root));
      }
      sync(root);
    });
  }
  function invalidateConfirmation() {
    document.querySelectorAll(selector).forEach((root) => {
      root.dataset.wbCartPending = 'true';
      root.setAttribute('aria-busy', 'true');
      const checkbox = root.querySelector('[data-wb-mto-checkbox]');
      if (checkbox) {
        checkbox.checked = false;
        checkbox.disabled = true;
      }
      let notice = root.querySelector('[data-wb-mto-update-notice]');
      if (!notice) {
        notice = document.createElement('p');
        notice.dataset.wbMtoUpdateNotice = 'true';
        notice.setAttribute('role', 'status');
        notice.append(document.createTextNode('Your cart has changed. Wait for the update before confirming delivery. If it does not finish, '));
        const refresh = document.createElement('a');
        refresh.href = window.location.href;
        refresh.textContent = 'refresh this page';
        notice.append(refresh, document.createTextNode('.'));
        root.append(notice);
      }
      sync(root);
    });
  }
  const quantityChanged = (event) => {
    const input = event.target;
    if (input.matches?.('input[type="number"][data-index]') && input.closest?.('cart-items, cart-drawer-items')) invalidateConfirmation();
  };
  document.addEventListener('input', quantityChanged, true);
  document.addEventListener('change', quantityChanged, true);
  function block(event, checkout) {
    const root = Array.from(document.querySelectorAll(selector)).find((node) => node.dataset.wbCheckoutId === checkout?.id);
    if (!root || ready(root)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    root.querySelector('[role="alert"]').hidden = false;
    root.querySelector('[data-wb-mto-checkbox]')?.focus();
    sync(root);
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('cart-remove-button')) invalidateConfirmation();
    const checkout = event.target.closest?.('[name="checkout"]');
    if (checkout) block(event, checkout);
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches?.('form[action*="/cart/add"]') && !form.querySelector('[name="id"]')?.disabled) invalidateConfirmation();
    const checkout = event.submitter?.name === 'checkout' ? event.submitter :
      Array.from(document.querySelectorAll('[name="checkout"]')).find((button) => button.form === event.target);
    if (checkout) block(event, checkout);
  }, true);
  // The complete cart footer is refreshed with the item list. A changed item
  // set gets a new, unchecked confirmation rather than retaining stale consent.
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; initialize(); });
  };
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();

